import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import MemeForm from "./components/MemeForm";
import MemeHolder from "./components/MemeHolder";
import domtoimage from "dom-to-image-more";
import Footer from "./components/Footer";

import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function App() {
  const [displayMeme, setDisplayMeme] = useState({});
  const [topMemes, setTopMemes] = useState([]);
  const [topText, setTopText] = useState("Top text");
  const [bottomText, setBottomText] = useState("Bottom text");

  const topMemesURL = "https://api.imgflip.com/get_memes";

  const fetchMemes = (url) => {
    axios.get(url).then((res) => {
      const memes = res.data.data.memes;
      const filteredMemes = memes
        .filter(
          (meme) =>
            meme.box_count < 3 &&
            meme.name !== "Drake Hotline Bling" &&
            meme.name !== "Two Buttons"
        )
        .reverse();
      setDisplayMeme(filteredMemes[0]);
      setTopMemes(filteredMemes);
    });
  };

  useEffect(() => {
    fetchMemes(topMemesURL);
  }, []);

  const selectMeme = (event) => {
    const index = event.target.value;
    setDisplayMeme(topMemes[index]);
  };

  const handleTextInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "text0") {
      setTopText(value);
    } else {
      setBottomText(value);
    }
  };

  const submitMeme = () => {
    domtoimage
      .toPng(document.getElementById("memeDisplay"), { quality: 1 })
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = "meme.png";
        link.href = dataUrl;
        link.click();
      });
  };

  return (
    <div className="App">
      <Container>
        {/* <Jumbotron> */}
        <h1>React Meme Generator</h1>
        <h3>{displayMeme.name}</h3>
        <Row>
          <Col>
            <MemeHolder
              url={displayMeme.url}
              name={displayMeme.name}
              topText={topText}
              bottomText={bottomText}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MemeForm
              topMemes={topMemes}
              displayMeme={displayMeme}
              select={selectMeme}
              handleChange={handleTextInput}
              submit={submitMeme}
              topText={topText}
              bottomText={bottomText}
            />
          </Col>
        </Row>
        {/* </Jumbotron> */}
        <Row></Row>
        <Footer />
      </Container>
    </div>
  );
}
